import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M10 2h4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 14v-4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M4 13a8 8 0 0 1 8-7 8 8 0 1 1-5.3 14L4 17.6",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M9 17H4v5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "TimerReset";
const TimerReset = memo(themed(Icon));
export {
  TimerReset
};
//# sourceMappingURL=timer-reset.js.map
